import { render, staticRenderFns } from "./SurveyApprovalsListing.vue?vue&type=template&id=833478f4"
import script from "./SurveyApprovalsListing.vue?vue&type=script&lang=js"
export * from "./SurveyApprovalsListing.vue?vue&type=script&lang=js"
import style0 from "./SurveyApprovalsListing.vue?vue&type=style&index=0&id=833478f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports